import { Box } from '@mantine/core'
import React from 'react'
import { clsx } from '@mantine/styles'

import classes from './Page.module.scss'

export function Page({
  children,
  testId,
  fullWidthContent,
  contentFirstOnMobile
}: Readonly<{
  children: React.ReactNode
  testId?: string
  fullWidthContent?: boolean
  contentFirstOnMobile?: boolean
}>) {
  return (
    <Box
      data-testid={testId}
      className={clsx(classes.PageWrapper, {
        [classes.WithFullWidthContent]: fullWidthContent,
        [classes.ContentFirstOnMobile]: contentFirstOnMobile
      })}
    >
      {children}
    </Box>
  )
}
